export default __webpack_public_path__ + "static/media/25.f56a9584.png";